import api from './client';
import { Timestamp } from 'firebase/firestore';
import type { GeneratedDocument, DocumentSignature, DocumentForm } from 'types/generated_document';

function tsToIso(ts: Timestamp | undefined): string | undefined {
  if (!ts) return undefined;
  return ts.toDate().toISOString();
}

function buildFormPayload(form: DocumentForm | undefined): any {
  if (!form) return undefined;
  return {
    id: form.id,
    categories: form.categories.map((cat) => ({
      id: cat.id,
      name: cat.name,
      fields: cat.fields.map((f) => {
        let value = f.value;
        if (f.type === 'date' && typeof value === 'number') {
          value = new Date((value as number) * 1000).toISOString();
        } else if (f.type === 'date' && value instanceof Timestamp) {
          value = (value as Timestamp).toDate().toISOString();
        }
        return { id: f.id, label: f.label, type: f.type, options: f.options, value };
      }),
    })),
  };
}

function buildSignaturesPayload(signatures: DocumentSignature[]) {
  return signatures.map((s) => ({
    id: s.id,
    signer_type: s.signer_type,
    signer_id: s.signer_id,
    signer_name: s.signer_name,
    signer_email: s.signer_email,
    status: s.status,
    signed_at: tsToIso(s.signed_at),
    signature_base64: s.signature_base64,
  }));
}

export const generatedDocumentsApi = {
  generate: async (params: {
    generatedDocument: GeneratedDocument;
    signatures: DocumentSignature[];
    photoIds: string[];
    projectId: string;
    orgId: string;
    folderId?: string;
  }): Promise<any> => {
    const { generatedDocument, signatures, photoIds, projectId, orgId, folderId } = params;

    const payload = {
      project_id: projectId,
      org_id: orgId,
      name: generatedDocument.name,
      infos: {
        title: generatedDocument.infos.title,
        project_name: generatedDocument.infos.project_name,
        full_adress: generatedDocument.infos.full_adress,
        date: tsToIso(generatedDocument.infos.date),
        conductor_display_name: generatedDocument.infos.conductor_display_name,
      },
      body: generatedDocument.body,
      form: buildFormPayload(generatedDocument.form),
      signatures: buildSignaturesPayload(signatures),
      photo_ids: photoIds,
      folder_id: folderId,
    };

    const { data } = await api.post('/generated-documents/generate', payload, {
      timeout: 60000,
    });
    return data;
  },
};
